import { isBrowser } from '@/shared/utils/window';
import StorageInterface from './types';

class LocalStorage implements StorageInterface {
  set(key: string, value: string) {
    if (isBrowser()) {
      window.localStorage.setItem(key, value);
    }
  }

  get(key: string) {
    if (isBrowser()) {
      return window.localStorage.getItem(key);
    }
    return '';
  }

  remove(key: string) {
    if (isBrowser()) {
      return window.localStorage.removeItem(key);
    }
  }
}

const localStorageInstance = new LocalStorage();

export default localStorageInstance;
